import React, { PureComponent } from 'react';
import './index.css';

class OrderList extends PureComponent {
  render() {
    const {
      className,
      items,
      ...props
    } = this.props;
    return (
      <div
        className={`nyl-order-list ${className}`}
        {...props}
      >
        {items.map((item, index) => (
          <div className="nyl-order-list-item" key={item}>
            <span className="nyl-order-list-item-number">{index + 1}</span>
            <span className="nyl-order-list-item-text">{item}</span>
          </div>
        ))}
      </div>
    );
  }
}

export default OrderList;
